import { AnswerDTO } from 'jobs/dtos/questions'
import uniqBy from 'lodash/uniqBy'

/**
 * Merges answers arrays.
 *
 * @param left
 * @param right
 */
export function mergeAnswers(
  left: AnswerDTO[],
  right: AnswerDTO[]
): AnswerDTO[] {
  return uniqBy([...right, ...left], 'id')
}
